import { createClientCityToCityRequest } from "../../data/clientCityToCityApi";
import { validateClientCityToCityPayload } from "../validator/validateClientCityToCityPayload";

export async function createClientCityToCityUseCase(payload) {
  const error = validateClientCityToCityPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createClientCityToCityRequest(payload);
}
